/* eslint-disable */
require('./back-1')
require('./back-1c')
require('./back-2')
require('./back-2c')
require('./back-3')
require('./back-3c')
require('./back')
require('./balance-scale')
require('./ban')
require('./blank')
require('./bon-cancelled')
require('./bon')
require('./burger')
require('./cal')
require('./cancel')
require('./cash')
require('./checkin')
require('./checkout')
require('./clock')
require('./close-text')
require('./close')
require('./collapse')
require('./copy-down')
require('./copy-price')
require('./copy')
require('./credit-card')
require('./delete')
require('./digging')
require('./down')
require('./download')
require('./edit')
require('./equals')
require('./euro-sign')
require('./expand')
require('./eye')
require('./female')
require('./fill-arrows')
require('./fill-cash-register')
require('./fill-connect')
require('./fill-dot')
require('./fill-fingerprint')
require('./fill-gauge')
require('./fill-guest')
require('./fill-hm')
require('./fill-home')
require('./fill-inquiry')
require('./fill-lock')
require('./fill-logout')
require('./fill-more')
require('./fill-notification')
require('./fill-numbers')
require('./fill-onrequest')
require('./fill-plan')
require('./fill-quote')
require('./fill-refresh')
require('./fill-report')
require('./fill-reservation')
require('./fill-search')
require('./fill-settings')
require('./fill-sort')
require('./fill-support')
require('./fill-tablet-check')
require('./fill-test')
require('./fill-unknown')
require('./fill-weather-clear-day')
require('./fill-weather-clear-night')
require('./fill-weather-cloudy')
require('./fill-weather-fog')
require('./fill-weather-hail')
require('./fill-weather-partly-cloudy-day')
require('./fill-weather-partly-cloudy-night')
require('./fill-weather-rain')
require('./fill-weather-sleet')
require('./fill-weather-snow')
require('./fill-weather-thunderstorm')
require('./fill-weather-tornado')
require('./fill-weather-wind')
require('./filter')
require('./forward-1')
require('./forward-1c')
require('./forward-2')
require('./forward-2c')
require('./forward-3')
require('./forward-3c')
require('./gear')
require('./genderneutral')
require('./hammer')
require('./html')
require('./in')
require('./info')
require('./less')
require('./link')
require('./loading-burger')
require('./lock')
require('./magic-wand')
require('./male')
require('./noshow')
require('./out')
require('./overbooking')
require('./pdf')
require('./pen-tablet')
require('./per-night')
require('./per-person')
require('./per-room')
require('./per-stay')
require('./plus')
require('./pre-payment')
require('./printer')
require('./receipt')
require('./refresh')
require('./replace')
require('./roomplan-airbnb')
require('./roomplan-booking')
require('./roomplan-channel')
require('./roomplan-expedia')
require('./roomplan-feratel')
require('./roomplan-hrs')
require('./roomplan-paid')
require('./roomplan-traumferienwohnungen')
require('./roomplan-unpaid')
require('./roomplan-website')
require('./save')
require('./search')
require('./select-all')
require('./send-email')
require('./shrink')
require('./split')
require('./subnav')
require('./transfer')
require('./undo')
require('./unlink')
require('./unlock')
require('./upload')
require('./wire-transfer')



// WEBPACK FOOTER //
// ./src/assets/icons/index.js